<template>
  <DoughnutChart
      :chart-data="rateAgentOverallChartData"/>
</template>

<script>
import DoughnutChart from "components/charts/DoughnutChart";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "RateAgentOverall",
  components: {
    DoughnutChart
  },
  mounted() {
    this.refresh()
  },
  computed: {
    ...mapGetters('rating', ['rateAgentOverallChartData'])
  },
  methods: {
    ...mapActions('rating', ['listRateAgentOverall']),
    refresh() {
      this.listRateAgentOverall()
    }
  }
}
</script>

<style scoped>

</style>